import { IPagination } from './utils';
export interface IPaginationInfo {
  perPage: number;
  pageNo: number;
}

export class Pagination {
  private paginationInfo: IPaginationInfo;
  private totalItems: number;

  constructor(paginationInfo: IPaginationInfo, totalItems: number) {
    this.paginationInfo = paginationInfo;
    this.totalItems = totalItems;
  }

  getPagination(): IPagination {
    const isMoreItemsExist: boolean = this.totalItems >= this.paginationInfo.perPage;
    const currentPage: number = this.paginationInfo.pageNo;
    const itemsPerPage: number = this.paginationInfo.perPage;
    const totalItemsInLastResponse: number = this.totalItems || 0;

    const totalItems = isMoreItemsExist
      ? currentPage * itemsPerPage + 1
      : (currentPage - 1) * itemsPerPage + totalItemsInLastResponse;

    const noOfPages = isMoreItemsExist ? currentPage + 1 : currentPage;

    return {
      totalItems,
      noOfPages,
      perPage: itemsPerPage,
      pageNo: currentPage,
      totalItemsInLastResponse,
    };
  }
}
